import {
  BarChart3, BookOpen, Boxes, Calculator, ChefHat, CircleUserRound, Croissant, Factory, FileBarChart, Folder, Fuel, LayoutGrid, LifeBuoy, Lock, Map, PackageCheck,
  Receipt, ScrollText, SlidersHorizontal, Split, Store, Table2, Tags, Truck, Users, Wallet, Wheat, Sparkles, BadgePercent, Warehouse, type LucideIcon,
} from 'lucide-react';
import type { MenuNode } from '@/lib/types';

/** Ana menü grubu ikonu (Delphi ana menü TAG'leri 100..900) */
const GROUP_ICON: Record<number, LucideIcon> = {
  100: Croissant, 200: Wheat, 300: Users, 400: Receipt, 500: Wallet, 600: CircleUserRound, 700: BarChart3, 800: SlidersHorizontal, 900: LifeBuoy,
};
/** Fırın ekranları için anlamlı ikonlar (menü TAG) */
const LEAF_ICON: Record<number, LucideIcon> = {
  113: Truck, 125: Store, 114: Tags, 115: Tags, 127: Tags, 128: Tags, 116: ChefHat, 124: Factory, 117: Truck, 118: PackageCheck, 119: Split, 130: Fuel,
  129: Calculator, 123: Store, 120: ScrollText, 121: Receipt, 122: Store, 126: Map, 201: Boxes, 212: BookOpen, 211: Warehouse, 823: BadgePercent,
};
export function groupIcon(n: MenuNode): LucideIcon {
  if (n.tag && GROUP_ICON[n.tag]) return GROUP_ICON[n.tag];
  const t = n.title.toLocaleLowerCase('tr-TR');
  if (t.includes('servis')) return Croissant;
  if (t.includes('stok')) return Boxes;
  if (t.includes('cari')) return Users;
  if (t.includes('fatura')) return Receipt;
  if (t.includes('kasa') || t.includes('banka')) return Wallet;
  if (t.includes('rapor')) return BarChart3;
  return Folder;
}
export function leafIcon(kind: string, tag?: number): LucideIcon {
  if (tag && LEAF_ICON[tag]) return LEAF_ICON[tag];
  switch (kind) {
    case 'dizayn': case 'dizayn-belge': return LayoutGrid;
    case 'tablo': return Table2;
    case 'rapor-grup': return FileBarChart;
    case 'harici': return Lock;
    default: return Sparkles;
  }
}

export interface FlatItem { node: MenuNode; path: string[] }
/** Komut paleti için yaprak düğümler */
export function flatten(nodes: MenuNode[], path: string[] = []): FlatItem[] {
  const out: FlatItem[] = [];
  for (const n of nodes) {
    if (n.children?.length) out.push(...flatten(n.children, [...path, n.title]));
    else out.push({ node: n, path });
  }
  return out;
}

export const trLower = (s: string) => s.toLocaleLowerCase('tr-TR');

/** Türkçe karakter ve büyük/küçük harf duyarsız eşleşme; puan döner (0 = eşleşmedi) */
export function matchScore(text: string, q: string): number {
  if (!q) return 1;
  const t = trLower(text), s = trLower(q.trim());
  if (t === s) return 4;
  if (t.startsWith(s)) return 3;
  if (t.split(/[\s\-/·]+/).some((w) => w.startsWith(s))) return 2;
  if (t.includes(s)) return 1;
  // baş harfler (ör. "sf" → Satış Faturası)
  const ini = t.split(/[\s\-/]+/).map((w) => w[0]).join('');
  return ini.includes(s) ? 0.5 : 0;
}
